import React, { useEffect } from "react";

export default function NotFound() {
    useEffect(() => {
        let meta = document.querySelector('meta[name="robots"]');

        if (!meta) {
            meta = document.createElement("meta");
            meta.setAttribute("name", "robots");
            document.head.appendChild(meta);
        }

        meta.setAttribute("content", "noindex, nofollow");

        return () => {
            meta.setAttribute("content", "index, follow");
        };
    }, []);
  return (
<div style={styles.page}>
    <div style={styles.card}>
        <div style={styles.iconWrapper}>
            <span style={styles.code}>404</span>
        </div>
        <h1 style={styles.title}>Page not found</h1>
        <p style={styles.text}>
            The page you're looking for doesn't exist.
        </p>
        <a href="/" style={styles.link}>
            Go back home →
        </a>
    </div>
</div>
  );
}

const styles = {
  page: {
    fontFamily: "Inter, Arial, sans-serif",
    display: "flex",
    minHeight: "100vh",
    justifyContent: "center",
    alignItems: "center",
    padding: "24px",
    background: "#f8fafc",
    color: "#0f172a",
    textAlign: "center",
  },
  card: {
    width: "100%",
    maxWidth: "520px",
    background: "#ffffff",
    border: "1px solid #e5e0d3",
    borderRadius: "22px",
    padding: "48px 40px",
    boxShadow: "0 24px 48px -20px rgba(25,24,23,0.25)",
  },
  iconWrapper: {
    width: "96px",
    height: "96px",
    margin: "0 auto 24px",
    borderRadius: "50%",
    background: "#f1f5f9",
    border: "1px solid #f5c9a6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  code: {
    color: "#0f172a",
    fontSize: "28px",
    fontWeight: 700,
  },
  title: {
    margin: "0 0 12px",
    fontFamily: "'Space Grotesk', Inter, sans-serif",
    letterSpacing: "-0.02em",
    fontSize: "32px",
  },
  text: {
    color: "#64748b",
    margin: "0 auto 32px",
    fontSize: "16px",
    lineHeight: 1.7,
  },
  link: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "140px",
    padding: "12px 20px",
    borderRadius: "999px",
    background: "#0f172a",
    color: "#fff",
    fontWeight: 700,
    fontSize: "14px",
    textDecoration: "none",
  },
};
